import autobind from 'core-decorators/lib/autobind';
import { connect } from 'react-redux';
import Vidi from 'vidi';

import { isVideoPlaying } from 'widget/selectors/video-playback-status';

import VIDEO_PLAYBACK_STATUSES from 'widget/constants/video-playback-status';

import Spinner from 'shared/components/spinner/loading-spinner';

import {
  setPlaybackStatus,
} from 'widget/redux/client/actions/change-playback-status';

import VideoPlayerWrapper from 'video-player-react';


@connect(
  state => ({
    isVideoPlaying: isVideoPlaying(state),
  }),
  {
    setPlaybackStatus,
  }
)
export default class InternalPlayer extends React.Component {

  static propTypes = {
    children: React.PropTypes.any,
    videoUrls: React.PropTypes.object,
    className: React.PropTypes.string,

    width: React.PropTypes.number,
    height: React.PropTypes.number,

    onError: React.PropTypes.func,
    onFullScreenClicked: React.PropTypes.func,
    onFullScreenChanged: React.PropTypes.func,

    setPlaybackStatus: React.PropTypes.func,

    volume: React.PropTypes.number,
    isVideoPlaying: React.PropTypes.bool,
    muted: React.PropTypes.bool,
    loop: React.PropTypes.bool,
  };

  static defaultProps = {
    onError: _.noop,
    onFullScreenClicked: _.noop,
    onFullScreenChanged: _.noop,

    paused: true,
    muted: false,
    volume: 1,
    width: 640,
    height: 360,
    loop: false,
  };

  @autobind
  passFullScreenEnter() {
    this.props.onFullScreenChanged(true);
  }

  @autobind
  passFullScreenExit() {
    this.props.onFullScreenChanged(false);
  }

  @autobind
  setPlayStatus() {
    this.props.setPlaybackStatus(VIDEO_PLAYBACK_STATUSES.PLAYING);
  }

  @autobind
  setPauseStatus() {
    if (this.props.isVideoPlaying) {
      this.props.setPlaybackStatus(VIDEO_PLAYBACK_STATUSES.PAUSED);
    }
  }

  @autobind
  setEndStatus() {
    this.props.setPlaybackStatus(VIDEO_PLAYBACK_STATUSES.ENDED);
  }

  get video() {
    const { width, height, videoUrls, volume, muted, loop, isVideoPlaying, onError } = this.props;
    const vidiUrls = _.map(videoUrls, this.toVidiTypes);

    return (
      <VideoPlayerWrapper preload="metadata"
                          width={width}
                          paused={!isVideoPlaying}
                          height={height}
                          volume={volume}
                          muted={muted}
                          loop={loop}
                          onError={onError}
                          onPlay={this.setPlayStatus}
                          onPause={this.setPauseStatus}
                          onEnd={this.setEndStatus}
                          onFullScreenEnter={this.passFullScreenEnter}
                          onFullScreenExit={this.passFullScreenExit}
                          src={vidiUrls} />
    );
  }


  toVidiTypes(url, type) {
    if (/mp4/i.test(type)) {
      return { url, type: Vidi.MediaStreamTypes.MP4, name: /[0-9]+p/i.exec(type)[0] };
    }
    if (/mpd/i.test(type)) {
      return { url, type: Vidi.MediaStreamTypes.DASH };
    }
    if (/m3u8/i.test(type)) {
      return { url, type: Vidi.MediaStreamTypes.HLS };
    }
    if (/webm/i.test(type)) {
      return { url, type: Vidi.MediaStreamTypes.WEBM };
    }
    return null;
  }


  render() {
    const { videoUrls } = this.props;
    if (!videoUrls) {
      return <Spinner />;
    }

    return this.video;
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/new-player-internal.js